import React, { useState } from "react";
import { TitleText } from "../../../ui/Text";
import styled from "styled-components";
import { ObjectiveItem } from "./ObjectiveItem";
import AddLinkageForm from "./AddLinkageForm";
import Modal from "../../../ui/Modal";
import get from "lodash/get";
import { GetHook } from "../../../api/api";
import { STRATEGYMAP_URL } from "../../../api/urls";
import { useParams, useLocation } from "react-router-dom";
import { CloseIcon } from "../../../assets/svg/CloseIcon";
import Axios from "../../../utils/axios";
import { toast } from "react-toastify";
interface IProps {
  primaryObjectiveId?: any;
  perspectives?: any;
  scorecard_id?: any;
}

export const LInkedObjectivesSection = ({
  primaryObjectiveId,
  scorecard_id,
  perspectives,
}: IProps) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const params = useParams();
  const location = useLocation();
  const { data: objectives, reload } = GetHook(
    primaryObjectiveId
      ? `${STRATEGYMAP_URL}/${get(
          params,
          "strategymapId"
        )}/objective?primary_objective_id=${primaryObjectiveId}`
      : "null"
  );

  const parsedPerspectives = perspectives.map((item) => ({
    label: get(item, "perspective_name"),
    value: get(item, "perspective_id"),
  }));

  const handleDelete: any = (id) => {
    Axios.delete(`${STRATEGYMAP_URL}/${get(params, "strategymapId")}/objective/${id}`)
      .then((res) => {
        toast.success("Linkage deleted successfully");
        reload(get(location, "key"));
      })
      .catch((err) => toast.error("Unable to delete linkage"));
  };

  const closeModal = () => {
    setisModalOpen(false);

    reload(get(location, "key"));
  };
  return (
    <LinkedObjectives>
      <LinkedObjectivesHeader>
        <TitleText>Linked Objectives</TitleText>
        <TitleText onClick={() => setisModalOpen(!isModalOpen)}>
          Add new linkage
          <span style={{ color: "#01A8CE", marginLeft: "10px" }}>+</span>
        </TitleText>
      </LinkedObjectivesHeader>
      <LinkedObjectivesBody>
        {objectives.map((objective) => (
          <LinkedItem>
            <ObjectiveItem
              to={``}
              label={get(objective, "linked_objective.perspective_name")}
              title={get(objective, "linked_objective_name")}
              isInactive={true}
            />
            <CloseIcon onClick={() => handleDelete(get(objective, 'primary_objective_id'))} />
          </LinkedItem>
        ))}
      </LinkedObjectivesBody>
      {isModalOpen && (
        <Modal
          title={"Add new linkage"}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        >
          <AddLinkageForm
            closeModal={closeModal}
            setHandleSubmit={setHandleSubmit}
            perspectiveOptions={parsedPerspectives}
            scorecard_id={scorecard_id}
            primaryObjective={primaryObjectiveId}
          />
        </Modal>
      )}
    </LinkedObjectives>
  );
};

const LinkedObjectives = styled.div`
  display: grid;
  grid-template-rows: 4em auto;
`;

const LinkedObjectivesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeeff;
  padding: 0 2em;
  ${TitleText} {
    display: flex;
    height: 100%;
    align-self: center;
  }
`;
const LinkedObjectivesBody = styled.div`
  height: 100%;
  width: 100%;
`;
const LinkedItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 2em;
`;
